import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    msgType: null,
    msgTxt: null,
    ldata: null,
    loading: false,
  }),
  actions: {
    setErrorMessage(message, type) {
      this.msgTxt = message;
      this.msgType = type;
    },
    clearErrorMessage() {
      this.msgTxt = "";
      this.msgType = "";
    },
    setLdata() {
      this.ldata = JSON.parse(localStorage.getItem("ldata"));
    },
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
    },
  },

  getters: {},
});
